import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'sheba-google-play-icon',
  templateUrl: 'google-play.svg',
  host: {
    class: 'contents'
  },
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GooglePlayIcon { }
